module.exports = __webpack_public_path__ + "img/gn_03.ea57ba09.png";